var map = {
	"./alert.svg": 34262,
	"./character_filling_form.svg": 29614,
	"./character_with_pen.svg": 95420,
	"./customers_empty.svg": 97487,
	"./icon-file.svg": 36762,
	"./icon-suurennuslasi.svg": 52977,
	"./industries/animalcare.svg": 14374,
	"./industries/beauty.svg": 71995,
	"./industries/cleaning.svg": 7468,
	"./industries/construction.svg": 60498,
	"./industries/consulting.svg": 14583,
	"./industries/courier.svg": 73278,
	"./industries/graphic_design.svg": 52280,
	"./industries/online_store.svg": 31490,
	"./industries/photography.svg": 30538,
	"./industries/programming.svg": 99500,
	"./industries/social_media.svg": 87687,
	"./industries/sports.svg": 48020,
	"./industries/vehicles.svg": 27646,
	"./invoice-financing/invoice-financing-doc.svg": 95028,
	"./invoice-financing/invoice-financing-letter.svg": 57074,
	"./invoice-financing/invoice-financing-person.svg": 4491,
	"./invoicing.svg": 12848,
	"./invoicing/debt-collection.svg": 26503,
	"./no_vehicles.svg": 50301,
	"./outboarding/step-0-1.svg": 16004,
	"./outboarding/step-1.svg": 82629,
	"./outboarding/step-2.svg": 29252,
	"./outboarding/step-3.svg": 62203,
	"./person_box.svg": 54555,
	"./person_question.svg": 6998,
	"./products_empty.svg": 75810,
	"./registration-flow/flow_1.svg": 12669,
	"./registration-flow/flow_2.svg": 96508,
	"./registration-flow/flow_3.svg": 65331,
	"./registration-flow/flow_4.svg": 13754,
	"./registration-flow/flow_5.svg": 14505,
	"./registration-flow/flow_6.svg": 8712,
	"./registration-flow/flow_7.svg": 66239,
	"./registration-flow/flow_8.svg": 37142
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71332;